import FetchApi from "../util/fetchApi";

import store from "../store";
import { showToast } from "../store/actions";

const fetchApi = new FetchApi();

export default class SQLService {
  async getMysqlSchemas(Workspace_id, Stage_id) {
    return (await fetchApi.get(`/mysql/${Workspace_id}/${Stage_id}/getSchemas`)).data;
  }

  async getMysqlTables(Workspace_id, Stage_id, postData) {
    return (await fetchApi.post(`/mysql/${Workspace_id}/${Stage_id}/getTables`, postData)).data;
  }

  async getMysqlResult(Workspace_id, Stage_id, postData) {
    return (
      await fetchApi.post(
        `/mysql/${Workspace_id}/${Stage_id}/runQuery`,
        postData,
        (data) => data,
        (error) => {
          if (error.response.status === 504) {
            store.dispatch(
              showToast({
                message: "Timeout due to long query. The query took too long to execute and could not be previewed.",
                type: "error",
              })
            );

            return { onErrorReturn: true, errorResponse: error.response };
          }
        }
      )
    )?.data;
  }
}
